import template from "./mail-log-list.html.twig";

const { Component, Mixin } = Shopware;
const { Criteria }         = Shopware.Data;

Component.register("email-log-list", {
    template,

    inject: [
        "repositoryFactory",
        "acl"
    ],

    mixins: [
        Mixin.getByName("notification"),
        Mixin.getByName("salutation"),
        Mixin.getByName("listing")
    ],

    data() {
        return {
            mailLogEntries: null,
            isLoading: false,
            isBulkLoading: false,
            total: 0,
            additionalFilters: []
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        columns() {
            return [
                {
                    property: "createdAt",
                    dataIndex: "createdAt",
                    label: this.$t("neti-incomplete-order-reminder.mail-log.list.columnCreatedAt"),
                    inlineEdit: "string",
                    allowResize: true,
                    primary: true
                },
                {
                    property: "email",
                    dataIndex: "email",
                    label: this.$t("neti-incomplete-order-reminder.mail-log.list.columnEmail"),
                    inlineEdit: "string",
                    allowResize: true,
                    primary: true
                },
                {
                    property: "mailed",
                    dataIndex: "mailed",
                    label: this.$t("neti-incomplete-order-reminder.mail-log.list.columnMailed"),
                    inlineEdit: "boolean",
                    allowResize: true,
                    primary: true
                },
                {
                    property: "condition",
                    dataIndex: "condition",
                    label: this.$t("neti-incomplete-order-reminder.mail-log.list.columnCondition"),
                    inlineEdit: "string",
                    allowResize: true,
                    primary: true
                },
            ];
        },

        repository() {
            return this.repositoryFactory.create("neti_incomplete_order_reminder_mail_log");
        },

        dateFilter() {
            return Shopware.Filter.getByName("date");
        },
    },

    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria();
            criteria.addSorting(
                Criteria.sort("neti_incomplete_order_reminder_mail_log.createdAt", "DESC")
            );

            this.setFilter(criteria);

            this.repository
                .search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.mailLogEntries = result;
                    this.isLoading      = false;
                    this.total          = result.total;

                    return result;
                });
        },

        onFilterChanged(filters) {
            this.additionalFilters = filters;
            this.getList();
        },

        setFilter(criteria)
        {
            const keys = Object.keys(this.additionalFilters);

            keys.forEach(key => {
                const value = this.additionalFilters[key];
                switch (key) {
                    case "conditions":
                        if(Array.isArray(value) && value.length > 0) {
                            criteria.addFilter(Criteria.equalsAny('condition', value));
                        }
                        break;
                    case "mailed":
                        if(value !== null) {
                            criteria.addFilter(Criteria.equals("mailed", value === true ? 1 : 0));
                        }
                        break;
                    case "createdFrom":
                        criteria.addFilter(Criteria.range("createdAt", {
                            gte: value
                        }));
                        break;
                    case "createdTo":
                        criteria.addFilter(Criteria.range("createdAt", {
                            lte: value
                        }))
                        break;
                    case "email":
                        criteria.addFilter(Criteria.contains("email", value));
                        break;
                }
            })
        },
    }
});
